module.exports = __webpack_public_path__ + "img/hero-3s.3518ca8.jpg";